<div class="dialog-header">
  <h2 mat-dialog-title>List of MOU Files</h2>

  <button
    class="mat-close-btn"
    mat-button
    (click)="closeDialog()"
    aria-label="Close"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  @if (!isLoading && mouList.length > 0) {
    <div class="table-container mat-elevation-z8">
      <custom-table
        [tableData]="mouList"
        [tableColumns]="tableColumns"
        [isLoading]="isLoading"
        [filterAttributes]="filterAttributes"
        isFilterPresent="true"
        hideTableTitle="true"
        [showBreadcrumb]="false"
        [tableTitle]="'MOU Files'"
        moduleType="admin"
        pageType="list-mou"
        [tableActions]="tableActions"
        [extraIgnoreFilterKeys]="['agreement_file', 'agreement_desc']"
        [extraIgnoreColumnNames]="[
          'agreement_file',
          'agreement_desc',
          'Agreement File',
          'Agreement Desc'
        ]"
        (tableActionEmitter)="tableActionEmitter($event)"
        (rowAction)="rowAction($event)">
      </custom-table>
    </div>
  }
</mat-dialog-content>